export default "__VITE_ASSET__DA1RqK8R__"